import React from "react";
import "../Education.css";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import { NavLink } from "react-router-dom";

import {
    FiHome,
    FiChevronRight,
    FiBookOpen,
} from "react-icons/fi";


const Education = () => {


    return (

        <>

            <Header />


            {/* =====================================================
                        EDUCATION HERO SECTION
            ===================================================== */}


            <section className="education-hero">


                <div className="education-overlay"></div>



                <div className="container">



                    <div className="education-hero-content">



                        <span className="education-tag">

                            Education Technology Solutions

                        </span>



                        <h1>

                            Transforming
                            <span> Education </span>
                            Through Smart Digital Innovation

                        </h1>




                        <p>

                            Kishancart Digital (OPC) Private Limited
                            empowers schools, colleges, universities,
                            coaching institutes, and education
                            organizations with innovative digital
                            solutions. We develop smart education
                            platforms that improve learning experiences,
                            automate academic operations, enhance student
                            engagement, and enable data-driven education
                            management.

                        </p>




                        <div className="education-hero-btns">


                            {/* Buttons can be added here */}


                            {/*

                            <NavLink
                                to="/contact"
                                className="primary-btn"
                            >

                                Contact Us

                            </NavLink>


                            <NavLink
                                to="/services"
                                className="secondary-btn"
                            >

                                Explore Services

                            </NavLink>

                            */}



                        </div>




                    </div>



                </div>



            </section>






            {/* =====================================================
                            BREADCRUMB
            ===================================================== */}



            <section className="education-breadcrumb">



                <div className="container">



                    <div className="breadcrumb">



                        <NavLink to="/">


                            <FiHome />


                            Home


                        </NavLink>




                        <FiChevronRight />




                        <span>


                            Solutions


                        </span>




                        <FiChevronRight />




                        <span className="active">


                            <FiBookOpen />

                            Education


                        </span>




                    </div>



                </div>



            </section>







            {/* =====================================================
                        EDUCATION OVERVIEW
            ===================================================== */}




            <section className="education-overview">



                <div className="container">





                    <div className="overview-grid">





                        {/* LEFT CONTENT */}





                        <div className="overview-content">





                            <span className="section-tag">


                                Digital Education Solutions


                            </span>






                            <h2>


                                Smart Technology for
                                <span> Modern Learning</span>


                            </h2>







                            <p>


                                Kishancart Digital (OPC) Private Limited
                                develops secure and scalable education
                                technology solutions that help schools,
                                universities, educators, and learning
                                organizations improve teaching quality,
                                simplify management, and deliver better
                                digital learning experiences.


                            </p>






                            <p>


                                Our education platforms enable online
                                learning, student management, digital
                                classrooms, academic automation,
                                examination management, and real-time
                                analytics. We help educational
                                institutions adopt modern technologies
                                to build efficient and connected learning
                                ecosystems.


                            </p>







                            <div className="overview-list">






                                <div className="overview-item">


                                    ✓ Learning Management System


                                </div>






                                <div className="overview-item">


                                    ✓ Student Management System


                                </div>






                                <div className="overview-item">


                                    ✓ Online Learning Platforms


                                </div>






                                <div className="overview-item">


                                    ✓ Virtual Classroom Solutions


                                </div>






                                <div className="overview-item">


                                    ✓ Digital Examination System


                                </div>






                                <div className="overview-item">


                                    ✓ Education Analytics Dashboard


                                </div>





                            </div>





                        </div>









                        {/* RIGHT CARDS */}







                        <div className="overview-cards">






                            <div className="overview-card">



                                <h3>


                                    Learning Management System


                                </h3>




                                <p>


                                    Manage courses, digital content,
                                    assignments, assessments, and
                                    learning activities through a
                                    centralized education platform.


                                </p>



                            </div>








                            <div className="overview-card">



                                <h3>


                                    Student Management


                                </h3>




                                <p>


                                    Manage student records, attendance,
                                    academic progress, communication,
                                    and institutional workflows.


                                </p>



                            </div>








                            <div className="overview-card">



                                <h3>


                                    Digital Classroom


                                </h3>




                                <p>


                                    Enable online classes, virtual
                                    learning environments, live sessions,
                                    and interactive educational content.


                                </p>



                            </div>








                            <div className="overview-card">



                                <h3>


                                    Education Analytics


                                </h3>




                                <p>


                                    Analyze student performance,
                                    learning trends, reports, and
                                    academic insights using real-time
                                    dashboards.


                                </p>



                            </div>






                        </div>





                    </div>





                </div>




            </section>





            {/* PART 2 STARTS HERE */}

            {/* =====================================================
            EDUCATION CHALLENGES
===================================================== */}


            <section className="education-challenges">


                <div className="container">


                    <div className="section-heading">


                        <span className="section-tag">

                            Industry Challenges

                        </span>




                        <h2>

                            Challenges in
                            <span> Modern Education Management</span>

                        </h2>




                        <p>

                            Educational institutions face challenges related
                            to digital learning adoption, student engagement,
                            administrative workload, online education,
                            academic management, and data accessibility.
                            Our digital education solutions help overcome
                            these challenges through modern technology.

                        </p>



                    </div>







                    <div className="challenge-grid">






                        <div className="challenge-card">


                            <h3>

                                Traditional Learning Methods

                            </h3>


                            <p>

                                Transform traditional teaching methods
                                into interactive digital learning experiences
                                with modern education technology platforms.

                            </p>


                        </div>








                        <div className="challenge-card">


                            <h3>

                                Student Engagement

                            </h3>


                            <p>

                                Improve student participation and learning
                                outcomes through interactive content,
                                digital classrooms, and personalized learning.

                            </p>


                        </div>








                        <div className="challenge-card">


                            <h3>

                                Academic Management

                            </h3>


                            <p>

                                Simplify student records, attendance,
                                examinations, and academic workflows
                                through automated management systems.

                            </p>


                        </div>








                        <div className="challenge-card">


                            <h3>

                                Remote Learning

                            </h3>


                            <p>

                                Enable seamless online education with
                                virtual classrooms, digital courses,
                                and remote learning solutions.

                            </p>


                        </div>








                        <div className="challenge-card">


                            <h3>

                                Data Management

                            </h3>


                            <p>

                                Securely manage student data, academic
                                reports, performance records, and
                                institutional information.

                            </p>


                        </div>








                        <div className="challenge-card">


                            <h3>

                                Digital Transformation

                            </h3>


                            <p>

                                Help educational organizations adopt
                                scalable digital platforms for efficient
                                and future-ready learning environments.

                            </p>


                        </div>






                    </div>



                </div>



            </section>









            {/* =====================================================
            EDUCATION SOLUTIONS
===================================================== */}



            <section className="education-solutions">



                <div className="container">





                    <div className="section-heading">



                        <span className="section-tag">

                            Our Education Solutions

                        </span>





                        <h2>


                            Comprehensive Digital Solutions for
                            <span> Education Industry</span>


                        </h2>





                        <p>


                            We develop smart, scalable, and technology-driven
                            education solutions that help institutions improve
                            teaching efficiency, enhance student experiences,
                            and build connected digital learning ecosystems.


                        </p>





                    </div>








                    <div className="solutions-grid">






                        <div className="solution-card">


                            <h3>

                                Learning Management System

                            </h3>


                            <p>

                                Manage courses, digital content,
                                assignments, assessments, and student
                                learning activities from one platform.

                            </p>


                        </div>








                        <div className="solution-card">


                            <h3>

                                E-Learning Platform

                            </h3>


                            <p>

                                Provide online courses, digital lessons,
                                educational resources, and flexible
                                learning experiences for students.

                            </p>


                        </div>








                        <div className="solution-card">


                            <h3>

                                Virtual Classroom Solutions

                            </h3>


                            <p>

                                Enable live online classes, video
                                sessions, interactive learning, and
                                remote education capabilities.

                            </p>


                        </div>








                        <div className="solution-card">


                            <h3>

                                Student Information System

                            </h3>


                            <p>

                                Manage student profiles, attendance,
                                academic records, communication,
                                and institutional data.

                            </p>


                        </div>








                        <div className="solution-card">


                            <h3>

                                Online Examination Platform

                            </h3>


                            <p>

                                Conduct secure online exams,
                                assessments, evaluations, and
                                automated result management.

                            </p>


                        </div>








                        <div className="solution-card">


                            <h3>

                                Mobile Learning Application

                            </h3>


                            <p>

                                Provide students and teachers with
                                mobile access to courses, learning
                                materials, and academic services.

                            </p>


                        </div>








                        <div className="solution-card">


                            <h3>

                                Education Marketplace

                            </h3>


                            <p>

                                Connect educators, students,
                                courses, and learning resources
                                through digital education platforms.

                            </p>


                        </div>








                        <div className="solution-card">


                            <h3>

                                Education Analytics Dashboard

                            </h3>


                            <p>

                                Analyze student performance,
                                attendance trends, academic reports,
                                and institutional insights.

                            </p>


                        </div>






                    </div>





                </div>




            </section>

            {/* =====================================================
            EDUCATION FEATURES
===================================================== */}


            <section className="education-features">


                <div className="container">



                    <div className="section-heading">



                        <span className="section-tag">

                            Key Features

                        </span>





                        <h2>

                            Everything Needed for a
                            <span> Modern Education Platform</span>

                        </h2>





                        <p>

                            Our education technology solutions include
                            powerful features designed to improve
                            learning experiences, simplify academic
                            operations, and support digital education
                            transformation.

                        </p>




                    </div>








                    <div className="features-grid">






                        <div className="feature-card">

                            <h3>

                                Smart Learning Management

                            </h3>

                        </div>








                        <div className="feature-card">

                            <h3>

                                Online Classes & Virtual Learning

                            </h3>

                        </div>








                        <div className="feature-card">

                            <h3>

                                Course Management System

                            </h3>

                        </div>








                        <div className="feature-card">

                            <h3>

                                Student Performance Tracking

                            </h3>

                        </div>








                        <div className="feature-card">

                            <h3>

                                Digital Content Management

                            </h3>

                        </div>








                        <div className="feature-card">

                            <h3>

                                Online Assessment System

                            </h3>

                        </div>








                        <div className="feature-card">

                            <h3>

                                Attendance Management

                            </h3>

                        </div>








                        <div className="feature-card">

                            <h3>

                                Teacher Management

                            </h3>

                        </div>








                        <div className="feature-card">

                            <h3>

                                Student Communication Portal

                            </h3>

                        </div>








                        <div className="feature-card">

                            <h3>

                                Education Reports & Analytics

                            </h3>

                        </div>








                        <div className="feature-card">

                            <h3>

                                Mobile Learning Application

                            </h3>

                        </div>








                        <div className="feature-card">

                            <h3>

                                Secure Cloud Platform

                            </h3>

                        </div>






                    </div>




                </div>



            </section>









            {/* =====================================================
            BUSINESS BENEFITS
===================================================== */}



            <section className="education-benefits">



                <div className="container">





                    <div className="section-heading">



                        <span className="section-tag">

                            Business Benefits

                        </span>






                        <h2>


                            Why Education Organizations Choose
                            <span> Kishancart Digital</span>


                        </h2>






                        <p>


                            Our education technology solutions help
                            schools, colleges, universities, and learning
                            organizations improve teaching quality,
                            automate operations, enhance student
                            engagement, and build future-ready digital
                            education ecosystems.


                        </p>





                    </div>









                    <div className="benefits-grid">






                        <div className="benefit-card">


                            <h3>

                                Improved Learning Experience

                            </h3>


                            <p>

                                Deliver interactive and personalized
                                learning experiences through digital
                                platforms, online resources, and
                                smart education tools.

                            </p>


                        </div>








                        <div className="benefit-card">


                            <h3>

                                Better Student Engagement

                            </h3>


                            <p>

                                Increase student participation with
                                interactive content, virtual classrooms,
                                and digital communication channels.

                            </p>


                        </div>








                        <div className="benefit-card">


                            <h3>

                                Reduced Administrative Work

                            </h3>


                            <p>

                                Automate admissions, attendance,
                                records, examinations, reporting,
                                and academic management processes.

                            </p>


                        </div>








                        <div className="benefit-card">


                            <h3>

                                Data-Driven Decisions

                            </h3>


                            <p>

                                Use education analytics, reports,
                                and performance insights to make
                                accurate academic decisions.

                            </p>


                        </div>








                        <div className="benefit-card">


                            <h3>

                                Scalable Education Platform

                            </h3>


                            <p>

                                Easily expand digital learning
                                services across multiple campuses,
                                courses, and education programs.

                            </p>


                        </div>








                        <div className="benefit-card">


                            <h3>

                                Future-Ready Digital Education

                            </h3>


                            <p>

                                Adopt modern technologies including
                                cloud platforms, automation, analytics,
                                and smart learning solutions.

                            </p>


                        </div>






                    </div>





                </div>




            </section>









            {/* =====================================================
                    FOOTER
===================================================== */}



         



            <Footer />

        </>

    );

};



export default Education;